import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class ChatMessageListItem {
  id: string;
  code: string;
  question: string;
  answer: string;
  createdAt: string;
  updatedAt: string;
}

export class ChatMessagesListResponse extends IPagination {
  @Type(() => ChatMessageListItem)
  results: ChatMessageListItem[];
}

export class ChatMessageResponse {
  @Type(() => ChatMessageListItem)
  result: ChatMessageListItem;
}

export class CreateChatMessageRequest {
  code: string;
  question: string;
  answer: string;
}

export class UpdateChatMessageRequest {
  question?: string;
  code?: string;
  answer?: string;
}

export class ChatMessageListQueryDto extends IQueryPaginationDto {
  code?: string;
  question?: string;
  answer?: string;
}
